import {
    VideoCameraOutlined,
    CodeOutlined,
    ShareAltOutlined,
    SearchOutlined,
    UserOutlined,
    HomeOutlined,
} from '@ant-design/icons';
import React from 'react';

export const clipAppDetail = {
    title: 'Clip App - Clone giao diện TikTok',
    description: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Tổng quan</h2>
            <p className="mb-4">
                Clip App là một dự án cá nhân được thực hiện với mục đích học tập và rèn luyện kỹ năng frontend. Đây là
                bản clone giao diện của ứng dụng TikTok, tập trung vào việc tái tạo trải nghiệm người dùng và các tính
                năng giao diện chính của nền tảng chia sẻ video phổ biến này.
            </p>
            <p className="mb-4">
                Được phát triển hoàn toàn bằng ReactJS và SCSS, dự án này giúp tôi hiểu sâu hơn về việc xây dựng giao
                diện người dùng phức tạp, quản lý state, và tổ chức cấu trúc component trong một ứng dụng web hiện đại.
                Mặc dù chỉ tập trung vào phần frontend và không có backend, dự án vẫn mang lại nhiều kinh nghiệm quý giá
                về các kỹ thuật thực tế trong phát triển giao diện web.
            </p>

            <h3 className="text-xl font-semibold mb-3 mt-6">Các tính năng chính</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <h4 className="font-semibold text-blue-700 mb-2">Trang chủ với feed video</h4>
                    <p className="text-sm text-gray-700">
                        Hiển thị danh sách video theo dạng cuộn vô tận, với các tùy chọn tương tác như thích, bình luận
                        và chia sẻ.
                    </p>
                </div>

                <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <h4 className="font-semibold text-green-700 mb-2">Tìm kiếm nội dung</h4>
                    <p className="text-sm text-gray-700">
                        Cho phép người dùng tìm kiếm video và tài khoản người dùng, với gợi ý và lịch sử tìm kiếm.
                    </p>
                </div>

                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                    <h4 className="font-semibold text-purple-700 mb-2">Trang cá nhân</h4>
                    <p className="text-sm text-gray-700">
                        Hiển thị thông tin người dùng, các video đã đăng và các tùy chọn cài đặt tài khoản.
                    </p>
                </div>

                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500">
                    <h4 className="font-semibold text-amber-700 mb-2">Tương tác xã hội</h4>
                    <p className="text-sm text-gray-700">
                        Các tính năng chia sẻ, theo dõi người dùng khác và khám phá tài khoản gợi ý.
                    </p>
                </div>
            </div>
        </>
    ),
    technologies: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Công nghệ sử dụng</h2>

            <div className="space-y-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <CodeOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Frontend & Styling</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/react-2.svg" alt="ReactJS" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">ReactJS</span>
                                <span className="text-xs text-gray-500 mt-1">Frontend Library</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/sass.png" alt="SCSS" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">SCSS</span>
                                <span className="text-xs text-gray-500 mt-1">CSS Preprocessor</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/javascript.png" alt="JavaScript" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">JavaScript</span>
                                <span className="text-xs text-gray-500 mt-1">Programming Language</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <CodeOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Development Tools</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/git.png" alt="Git" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Git</span>
                                <span className="text-xs text-gray-500 mt-1">Version Control</span>
                            </div>

                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/vscode.jpeg" alt="VS Code" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">VS Code</span>
                                <span className="text-xs text-gray-500 mt-1">Code Editor</span>
                            </div>

                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/postman.svg" alt="Postman" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Postman</span>
                                <span className="text-xs text-gray-500 mt-1">API Testing</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    features: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Tính năng chính</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <HomeOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Trang chủ & Feed Video</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Video cuộn dọc</span> với trải nghiệm giống ứng
                                        dụng gốc
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tùy chọn tương tác</span> thích, bình luận và
                                        chia sẻ
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-blue-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Thanh điều hướng</span> với các mục chính của
                                        ứng dụng
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4">
                            <img
                                src="/assets/images/projects/clip-app/trang-chu.jpg"
                                alt="Trang chủ Clip App"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-green-500 to-teal-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <SearchOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Tìm kiếm & Khám phá</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tìm kiếm nội dung</span> và tài khoản người dùng
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Gợi ý xu hướng</span> và từ khóa phổ biến
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-green-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Lịch sử tìm kiếm</span> và xóa lịch sử
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4">
                            <img
                                src="/assets/images/projects/clip-app/tim-kiem.jpg"
                                alt="Tìm kiếm trên Clip App"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <UserOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Trang cá nhân & Cài đặt</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Hồ sơ người dùng</span> với thông tin cá nhân và
                                        số liệu thống kê
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Danh sách video</span> đã đăng và đã thích
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-purple-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tùy chọn cài đặt</span> tài khoản và quyền riêng
                                        tư
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4">
                            <img
                                src="/assets/images/projects/clip-app/cai-dat-ca-nhan.jpg"
                                alt="Cài đặt cá nhân"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-amber-500 to-orange-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <ShareAltOutlined className="text-amber-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Tương tác xã hội</h3>
                    </div>

                    <div className="p-6">
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Chia sẻ nội dung</span> qua nhiều nền tảng khác
                                        nhau
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tài khoản gợi ý</span> để theo dõi và tương tác
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <div className="flex-shrink-0 w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <span className="text-amber-600 text-xs font-bold">✓</span>
                                </div>
                                <div>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Tính năng theo dõi</span> người dùng yêu thích
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <div className="mt-4 grid grid-cols-2 gap-3">
                            <img
                                src="/assets/images/projects/clip-app/chia-se.jpg"
                                alt="Chia sẻ nội dung"
                                className="rounded-lg shadow-sm"
                            />
                            <img
                                src="/assets/images/projects/clip-app/tai-khoan-goi-y.jpg"
                                alt="Tài khoản gợi ý"
                                className="rounded-lg shadow-sm"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    results: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Kết quả đạt được</h2>

            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <CodeOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Nâng cao kỹ năng Frontend</h3>
                        <p className="text-gray-700">
                            Cải thiện đáng kể kỹ năng làm việc với ReactJS và SCSS thông qua việc clone giao diện phức
                            tạp
                        </p>
                    </div>

                    <div className="bg-green-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <VideoCameraOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Hiểu sâu về UX/UI</h3>
                        <p className="text-gray-700">
                            Hiểu rõ hơn về thiết kế trải nghiệm người dùng trong ứng dụng video phổ biến
                        </p>
                    </div>

                    <div className="bg-purple-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <ShareAltOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Phát triển portfolio</h3>
                        <p className="text-gray-700">
                            Dự án đầu tay có giá trị để trưng bày trong portfolio cá nhân và chia sẻ với cộng đồng
                        </p>
                    </div>
                </div>
            </div>
        </>
    ),
    screenshots: [
        {
            url: '/assets/images/projects/clip-app/trang-chu.jpg',
            caption: 'Trang chủ với feed video',
        },
        {
            url: '/assets/images/projects/clip-app/tim-kiem.jpg',
            caption: 'Tìm kiếm nội dung',
        },
        {
            url: '/assets/images/projects/clip-app/cai-dat-ca-nhan.jpg',
            caption: 'Cài đặt cá nhân',
        },
        {
            url: '/assets/images/projects/clip-app/chia-se.jpg',
            caption: 'Tùy chọn chia sẻ',
        },
        {
            url: '/assets/images/projects/clip-app/tai-khoan-goi-y.jpg',
            caption: 'Tài khoản gợi ý',
        },
    ],
    teamSize: 1,
    duration: '2 tuần',
    role: 'Frontend Developer',
    architecture: 'Single Page Application',
    responsibilities: [
        'Thiết kế và phát triển giao diện người dùng',
        'Tạo các component ReactJS cho các tính năng khác nhau',
        'Styling với SCSS để tái tạo UI của TikTok',
        'Xử lý responsive design cho nhiều kích thước màn hình',
        'Sử dụng Postman để test các mock API',
        'Quản lý phiên bản code với Git',
    ],
};
